<template>
  <section
    class="w-full flex justify-center items-center relative"
    :class="[sectionRoundingClass, backgroundColorClass]"
    :aria-labelledby="sectionId"
  >
    <div class="container">
      <div
        class="w-full h-[220px] lg:h-[320px] flex flex-col justify-center relative z-10 pt-12"
      >
        <!-- Title & Description -->
        <div
          class="w-full flex flex-col mb-2 lg:mb-4"
          :class="color === 'white' ? 'text-white' : 'text-black'"
        >
          <!-- Title (h1 - ana başlık) -->
          <h1
            v-if="title"
            :id="sectionId"
            class="text-3xl md:text-4xl lg:text-5xl xl:text-[56px] uppercase font-saira font-black tracking-tight leading-none"
          >
            {{ title }}
          </h1>
          <!-- Title (h1 - ana başlık) -->
        </div>
        <!-- Title & Description -->

        <!-- Breadcrumb -->
        <UiBreadcrumb :data="breadcrumbs" :color="color" />
        <!-- Breadcrumb -->
      </div>
      <div
        class="absolute left-0 top-0 h-full w-full z-0 bg-center bg-cover"
        :style="backgroundStyle"
      ></div>
      <div
        v-if="media?.url"
        class="hero-image-mask absolute left-0 top-0 h-full w-full z-[1]"
      ></div>
    </div>
    <div
      v-if="siteSettingsStore.shape.heroShape"
      class="absolute left-0 w-full overflow-hidden leading-none z-10"
      :class="shapeWrapperClass"
    >
      <!-- Shape -->
      <svg
        :class="['w-full h-5 lg:h-10 block -z-10 relative', shapeFillColor]"
        preserveAspectRatio="none"
        width="100%"
        height="40"
        viewBox="0 0 1800 40"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 26.1652C0 26.1652 46.3491 19.8469 88.8889 19.4061C132.063 18.9653 168.889 19.4061 221.587 21.6102C293.333 24.5489 431.746 36.4509 505.397 29.9856C579.048 23.5203 582.222 23.2265 619.683 19.1122C661.587 14.4102 746.667 5.00616 852.063 5.44698C964.444 5.88779 1168.25 29.8387 1252.06 28.6632C1260.95 28.5162 1293.97 27.4877 1318.73 25.7244C1342.86 23.9612 1378.41 20.1408 1426.67 18.8183C1446.98 18.2306 1479.37 17.202 1516.83 17.4959C1526.35 17.6428 1556.83 18.0836 1593.02 19.8469C1629.21 21.6102 1662.86 24.402 1693.33 25.2836C1758.73 26.8999 1800 24.5489 1800 24.5489V40.4182H0V26.1652ZM144.127 23.8142C148.572 25.2836 156.825 24.402 171.429 24.402C186.032 24.402 210.159 26.1652 208.254 26.0183C206.349 25.8714 188.571 23.8142 170.159 23.2265C151.111 22.4918 140.318 22.3448 144.127 23.8142ZM260.952 27.7815C260.952 27.7815 276.19 28.0754 296.508 29.104C316.825 30.2795 361.905 33.2183 392.381 34.2468C444.444 35.8631 492.698 34.2468 488.254 34.0999C483.175 33.9529 427.302 34.9815 376.508 32.4836C355.556 31.455 317.46 29.2509 297.778 28.5162C276.825 27.6346 260.952 27.7815 260.952 27.7815ZM624.127 27.9285C613.333 28.9571 708.571 21.0224 741.587 18.9653C754.921 18.0836 780.952 16.6143 805.079 16.0265C829.841 15.4388 861.587 15.4388 860.952 15.2918C860.952 14.9979 824.127 14.1163 789.841 15.2918C755.556 16.4673 756.825 16.9081 741.587 17.6428C717.46 18.8183 634.921 26.8999 624.127 27.9285ZM535.873 30.2795C534.603 30.2795 540.952 30.8672 566.349 28.6632C591.746 26.4591 608.889 23.5203 610.159 23.2265C611.429 23.0795 587.937 25.8714 568.254 27.6346C549.206 29.3979 536.508 30.2795 535.873 30.2795ZM3.17456 31.6019C3.80945 31.455 15.238 29.9856 33.6506 27.9285C52.0634 25.8714 77.4603 23.8142 76.1904 23.9612C74.9207 23.9612 53.9683 24.8428 29.2064 27.6346C4.44446 30.4264 2.53967 31.7489 3.17456 31.6019ZM1601.27 23.3734C1600.63 23.6673 1613.33 23.6673 1629.84 25.1367C1646.35 26.606 1664.13 27.4877 1679.37 28.0754C1704.76 29.2509 1753.65 27.9285 1751.11 27.7815C1749.21 27.6346 1699.05 28.2224 1671.75 26.753C1657.78 26.0183 1656.51 26.0183 1635.56 24.402C1614.6 22.7857 1601.9 22.9326 1601.27 23.3734ZM1336.51 26.8999C1333.97 27.0469 1314.29 29.2509 1283.17 30.7203C1252.06 32.3366 1226.67 31.455 1226.67 31.8958C1226.67 32.3366 1233.02 33.2183 1266.03 32.3366C1299.05 31.455 1339.05 26.753 1336.51 26.8999ZM1345.4 30.5734C1344.13 30.4264 1323.81 32.4836 1309.21 33.0713C1294.6 33.5121 1297.14 33.806 1297.14 33.9529C1297.14 34.0999 1304.13 34.2468 1314.29 33.6591C1325.08 32.9244 1346.67 30.7203 1345.4 30.5734ZM1205.71 33.9529C1205.08 33.6591 1183.49 32.7774 1170.16 31.3081C1156.83 29.8387 1158.73 30.4264 1158.1 30.5734C1157.46 30.7203 1163.17 31.7489 1173.33 32.4836C1183.49 33.3652 1206.35 34.2468 1205.71 33.9529ZM1384.76 24.1081C1385.4 23.6673 1382.86 23.3734 1372.7 24.402C1362.54 25.4305 1356.19 26.3122 1358.73 26.1652C1361.27 26.0183 1364.44 25.5775 1374.6 24.9897C1385.4 24.402 1384.13 24.5489 1384.76 24.1081ZM1580.95 22.1979C1582.22 22.1979 1567.62 21.0224 1560 20.8755C1552.38 20.7285 1547.3 20.7285 1547.3 21.1693C1547.3 21.6102 1547.94 21.904 1557.46 21.7571C1567.62 21.6102 1579.68 22.1979 1580.95 22.1979ZM833.651 9.4143C834.286 9.26736 848.889 9.85512 881.27 9.85512C913.016 9.85512 967.619 13.3816 990.476 14.9979C1013.33 16.6143 926.984 9.26736 885.714 8.97349C844.444 8.67961 833.016 9.56124 833.651 9.4143Z"
        />
        <path
          d="M88.2538 13.9694C88.8888 14.1163 117.46 13.5285 133.968 13.9694C180.317 14.9979 241.905 18.6714 239.365 18.2306C236.825 17.7897 152.381 13.6755 131.429 13.3816C100.317 12.7938 87.6189 13.9694 88.2538 13.9694Z"
        />
        <path
          d="M356.19 26.0183C357.46 26.1652 384.762 27.4876 416.508 27.7815C448.254 28.0754 497.143 26.8999 494.603 27.0468C492.698 27.1938 457.143 29.6917 410.159 28.8101C363.175 27.9285 354.921 25.8713 356.19 26.0183Z"
        />
        <path
          d="M501.587 20.7285C502.222 20.8755 488.889 22.1979 481.27 22.3449C473.651 22.4918 468.571 22.3449 468.571 21.904C468.571 21.4632 469.206 21.1694 478.73 21.3163C489.524 21.4632 500.952 20.5816 501.587 20.7285Z"
        />
        <path
          d="M523.81 24.8428C523.81 24.9897 551.746 23.0795 563.81 21.6101C575.873 20.2877 603.175 17.0551 602.54 17.0551C601.905 16.9081 575.873 19.4061 562.54 20.8755C549.206 22.3448 523.81 24.6958 523.81 24.8428Z"
        />
        <path
          d="M819.048 1.18578C819.682 1.33272 848.254 0.744967 864.762 1.18578C911.111 2.21435 972.698 5.8878 970.159 5.44698C967.619 5.00617 883.175 0.891905 862.222 0.598029C831.111 0.0102768 818.413 1.03884 819.048 1.18578Z"
        />
        <path
          d="M1533.97 12.0592C1533.97 12.0592 1526.35 12.5 1515.56 12.2061C1504.76 11.9122 1478.73 10.8836 1463.49 11.1775C1436.83 11.7653 1416.51 15.1449 1419.05 14.9979C1421.59 14.9979 1446.35 11.7653 1473.65 12.2061C1485.08 12.353 1506.03 12.9408 1516.19 12.7938C1526.35 12.6469 1533.97 12.0592 1533.97 12.0592Z"
        />
        <path
          d="M1320.64 21.904C1319.37 21.7571 1307.94 23.0795 1293.33 23.5203C1278.73 23.8142 1280 23.9611 1280 24.255C1280 24.402 1291.43 24.8428 1301.59 24.255C1311.75 23.5203 1321.9 22.051 1320.64 21.904Z"
        />
        <path
          d="M1700.95 21.0224C1700.95 21.1693 1673.65 21.0224 1658.41 20.2877C1643.17 19.553 1626.67 17.4959 1626.67 17.349C1626.67 17.202 1643.81 18.5245 1659.05 19.4061C1673.65 20.2877 1700.32 20.8755 1700.95 21.0224Z"
        />
      </svg>
      <!-- Shape -->
    </div>
  </section>
</template>

<script setup>
import { computed } from "vue";
import { useLocalePath } from "#i18n";
import { useSiteSettingsStore } from "@/store/index";
const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  description: {
    type: String,
    default: "",
  },
  breadcrumbs: {
    type: Array,
    default: () => [],
  },
  media: {
    type: Object,
  },
  mask: {
    type: Boolean,
    default: false,
  },
  backgroundColor: {
    type: String,
    default: "first",
  },
  color: {
    type: String,
    default: "white",
  },
  animate: { type: Boolean, default: false },
});
const siteSettingsStore = useSiteSettingsStore();
const sectionRoundingClass = computed(() => {
  if (props.animate && siteSettingsStore.roundCorner && !siteSettingsStore.shape.heroShape) return '';
  if (siteSettingsStore.shape.heroShape) return 'mb-12 lg:mb-28';
  return '';
});

const backgroundColorClass = computed(() => {
  const bg = props.backgroundColor;
  if (bg === 'first') return 'bg-brand-first';
  if (bg === 'second') return 'bg-brand-second';
  if (bg === 'third') return 'bg-brand-third';
  if (bg === 'dark-first') return 'bg-brand-dark';
  if (bg === 'dark-second') return 'bg-brand-dark-second';
  if (bg === 'light-first') return 'bg-brand-light';
  if (bg === 'light-second') return 'bg-brand-light-second';
  return 'bg-brand-dark';
});

const shapeFillColor = computed(() => {
  if (props.media?.url) return 'fill-white';
  const bg = props.backgroundColor;
  if (bg === 'first') return 'fill-brand-first';
  if (bg === 'second') return 'fill-brand-second';
  if (bg === 'third') return 'fill-brand-third';
  if (bg === 'dark-first') return 'fill-brand-dark';
  if (bg === 'dark-second') return 'fill-brand-dark-second';
  if (bg === 'light-first') return 'fill-brand-light';
  if (bg === 'light-second') return 'fill-brand-light-second';
  return '';
});

const runtimeConfig = useRuntimeConfig();
const baseUrl = runtimeConfig.public.baseUrl;
// Bölüm için erişilebilirlik kimliği
const sectionId = "page-header-title";
const shapeWrapperClass = computed(() => {
  return props.media?.url ? '-bottom-[5px]' : '-bottom-[17px] lg:-bottom-[35px] rotate-180';
});
const backgroundStyle = computed(() => {
  if (!props.media?.url) return {};
  const url = props.media.url.startsWith('/img/') || props.media.url.startsWith('http')
    ? props.media.url
    : `${baseUrl}${props.media.url}`;
  return { backgroundImage: `url(${url})` };
});
</script>

<style lang="scss">
.hero-image-mask {
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.3) 0%,
    rgba(0, 0, 0, 0.6) 60%,
    rgba(0, 0, 0, 0.75) 100%
  );
}
</style>
